import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Skeleton } from "primereact/skeleton";
import { getProjectPendingRequest } from "../../services/wisdomServices/projectService";
import { getPendingRequestsByManagerRequest } from "../../services/wisdomServices/managerService";

function ManagerDashRequestsTable({ selectedProjectId = 0 }) {
  const [requests, setRequests] = useState([]);
  const [filters, setFilters] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(true);

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });

    setGlobalFilterValue("");
  };

  const loadRequests = async () => {
    setLoading(true);

    try {
      const list = selectedProjectId > 0
        ? await getProjectPendingRequest(selectedProjectId)
        : await getPendingRequestsByManagerRequest();

      setRequests(list || []);
    } catch (error) {
      console.error(error);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initFilters();
  }, []);

  useEffect(() => {
    loadRequests();
  }, [selectedProjectId]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const nextFilters = { ...filters };

    nextFilters.global.value = value;

    setFilters(nextFilters);
    setGlobalFilterValue(value);
  };

  const userBodyTemplate = (userRequests) => {
    const requestDate = moment(userRequests.date);

    return (
      <Link
        className="manager-dashboard-requests"
        to={`/manager/user-requests/${userRequests.userId}`}
        state={{
          month: requestDate.month(),
          year: Number.parseInt(requestDate.year()),
        }}
      >
        <strong>{userRequests.name}</strong>
      </Link>
    );
  };

  const typeBodyTemplate = (userRequests) => {
    return (
      <strong
        className={
          userRequests.type === "manualTime" ? "manualTime" : "overtime"
        }
      >
        {userRequests.type}
      </strong>
    );
  };

  const header = (
    <div className="users-table-header">
      <h5 className="manager-dash-table-titles">
        Requests: {requests.length}
      </h5>

      <div className="table-filters">
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Clear"
          outlined
          onClick={initFilters}
        />

        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
            style={{ paddingLeft: "2.25rem" }}
          />
        </IconField>
      </div>
    </div>
  );

  if (loading) {
    return <Skeleton width="100%" height="18rem" borderRadius="12px" />;
  }

  return (
    <DataTable
      value={requests}
      header={header}
      tableStyle={{ minWidth: "10rem" }}
      filters={filters}
      globalFilterFields={["Name", "name"]}
      emptyMessage="No requests found."
      onFilter={(e) => setFilters(e.filters)}
    >
      <Column header="User" body={userBodyTemplate} />
      <Column field="project" header="Project" />
      <Column header="Type" body={typeBodyTemplate} />
      <Column field="hours" header="Hours" />
    </DataTable>
  );
}

export default ManagerDashRequestsTable;